"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const apollo_1 = require("@yanzi/apollo");
const react_cirrus_1 = require("@yanzi/react-cirrus");
const react_1 = require("react");
function ApolloProvider({ children, errorHandler, }) {
    const { socket } = react_cirrus_1.useCirrus();
    const errorHandlerRef = react_1.useRef(errorHandler);
    const client = react_1.useMemo(() => apollo_1.createClient(socket, (...args) => errorHandlerRef.current(...args)), [socket]);
    react_1.useEffect(() => {
        errorHandlerRef.current = errorHandler;
    }, [errorHandler]);
    return jsx_runtime_1.jsx(client_1.ApolloProvider, Object.assign({ client: client }, { children: children }), void 0);
}
exports.ApolloProvider = ApolloProvider;
//# sourceMappingURL=index.js.map